import { MCOnboardings } from 'src/components/mc-onboarding/mc-onboardings/MCOnboardings'
import React from 'react'
import { ReloadWrapper } from 'src/components/wrapper/reload-wrapper/ReloadWrapper'

export const MCOnboardingsPage = () => {
  return (
    <ReloadWrapper>
      <div data-testid="dashboard-master-contractors-onboardings-page">
        <MCOnboardings />
      </div>
    </ReloadWrapper>
  )
}
